import { DashboardMonitoringConnStateT, DashboardMonitoringItemT, DashboardMonitoringWorkStateT } from 'shared/models/dashboard';

import DoughnutChart from './DoughnutChart';

type GeneralMonitoringProps = {
  data?: DashboardMonitoringItemT;
}
function GeneralMonitoring({ data }: GeneralMonitoringProps) {
  const formatConnStateLabels = [
    'Connected',
    'Connected with Errors',
    'Disconnected',
    'Never Connected',
  ];

  const formatConnStateValues = (values?: DashboardMonitoringConnStateT) => [
    values?.connected,
    values?.connectedWithErrors,
    values?.disconnected,
    values?.neverConnected,
  ] as number[];

  const formatWorkStateLabels = [
    'Working',
    'Warning',
    'Error',
    'Unknown',
  ];

  const formatWorkStateValues = (values?: DashboardMonitoringWorkStateT) => [
    values?.working,
    values?.warning,
    values?.error,
    values?.unknown || values?.noDeviceConfig || 0,
  ] as number[];

  return (
    <>
      <h3 style={{ marginTop: '1rem' }}>General monitoring</h3>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          columnGap: '2rem',
          justifyContent: 'space-between',
          marginTop: '2.5rem',
          rowGap: '1rem',
        }}
      >
        <DoughnutChart title="Packet flows" labels={formatWorkStateLabels} values={formatWorkStateValues(data?.flowsState)} />
        <DoughnutChart title="Sources" labels={formatConnStateLabels} values={formatConnStateValues(data?.lpwanConn)} />
        <DoughnutChart title="Device SCHC Profiles" labels={formatWorkStateLabels} values={formatWorkStateValues(data?.schcProfilesState)} />
        <DoughnutChart title="IP Networks" labels={formatConnStateLabels} values={formatConnStateValues(data?.ipNetworkConn)} />
      </div>
    </>
  );
}

export default GeneralMonitoring;
